import { EdgeDevice } from '@api';
import moment from 'moment';
import { TranslationService } from '../../transloco/services/translation.service';

export function getRemainingActiveLiveData(translationService: TranslationService, edgeDevice?: EdgeDevice) {
    if (edgeDevice?.isLiveDataEnabled !== true || edgeDevice?.liveDataEnabledAt == null) {
        return { message: null, remainingInMinutes: -1 };
    }
    const liveDataActivationTime = 59;
    const liveDataEnabledAt = edgeDevice.liveDataEnabledAt;
    const remainingInMinutes = liveDataActivationTime - moment().diff(moment(liveDataEnabledAt), 'minutes');

    return { message: translationService.translate('dashboards.widgets.liveDataMessage', { remainingInMinutes }), remainingInMinutes: remainingInMinutes };
}
